// extracted by mini-css-extract-plugin
module.exports = {"flower":"components_flower__38_A5"};